"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var PopupModal_1 = require("../PopupModal");
var Swiper_1 = require("@devsisters/ui-common/lib/Swiper");
var icons_1 = require("../icons");
var styles = require("./index.module.css");
var PopupTextCarousel = /** @class */ (function (_super) {
    __extends(PopupTextCarousel, _super);
    function PopupTextCarousel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { openCount: 0 };
        return _this;
    }
    PopupTextCarousel.prototype.componentDidUpdate = function (prevProps) {
        if (!prevProps.open && this.props.open)
            this.setState({ openCount: this.state.openCount + 1 });
    };
    PopupTextCarousel.prototype.render = function () {
        var _a = this.props, className = _a.className, style = _a.style, modalClassName = _a.modalClassName, modalStyle = _a.modalStyle, paneClassName = _a.paneClassName, paneStyle = _a.paneStyle, type = _a.type, open = _a.open, close = _a.close, slideTexts = _a.slideTexts, _b = _a.initialSlide, initialSlide = _b === void 0 ? 0 : _b;
        var openCount = this.state.openCount;
        return (React.createElement(PopupModal_1.default, { className: className, style: style, modalClassName: modalClassName, modalStyle: modalStyle, paneClassName: classnames_1.default(styles.pane, paneClassName), paneStyle: paneStyle, type: type, open: open, close: close },
            React.createElement(Swiper_1.default, { key: initialSlide + " " + openCount, containerClass: classnames_1.default(styles.swiper, styles[type]), initialSlide: initialSlide, slidesPerView: "auto", speed: 500, pagination: {
                    el: '.swiper-pagination' + ("." + styles.pagination),
                    type: 'fraction',
                }, navigation: {
                    nextEl: '.swiper-button-next' + ("." + styles.nextButton),
                    prevEl: '.swiper-button-prev' + ("." + styles.prevButton),
                }, renderNextButton: function () { return (React.createElement(icons_1.NextIcon, { className: classnames_1.default('swiper-button-next', styles.nextButton) })); }, renderPrevButton: function () { return (React.createElement(icons_1.PrevIcon, { className: classnames_1.default('swiper-button-prev', styles.prevButton) })); }, parallax: true, loop: true, allowTouchMove: type === 'mobile' }, slideTexts.map(function (slideText, i) { return (React.createElement("div", { key: i, className: styles.slide },
                React.createElement("div", { className: styles.title, "data-swiper-parallax": "30%", "data-swiper-parallax-opacity": "0" }, slideText.title),
                React.createElement("div", { className: styles.description, "data-swiper-parallax": "0%", "data-swiper-parallax-opacity": "0" }, slideText.description))); }))));
    };
    return PopupTextCarousel;
}(React.Component));
exports.default = PopupTextCarousel;
